module.exports = __webpack_public_path__ + "media/images/icons/apartment-6c238459390f9836ed42ec32dbcfaf34.svg";